import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function MoonPhases() {
    const moonPhases = ['🌑', '🌒', '🌓', '🌔', '🌕', '🌖', '🌗', '🌘'];

    // Helper function to generate the moon phases array with a repeating pattern
    const generatePhases = () => {
        let phases : any= [];
        for (let i = 0; i < 20; i++) { // Adjust this number to ensure full screen coverage
            phases = phases.concat(moonPhases);
        }
        return phases;
    };

    return (
        <motion.div
            className="flex opacity-15 absolute top-0 bottom-0 my-auto flex-row gap-2.5 overflow-visible"
            initial={{ x: 0 }}
            animate={{ x: -1000 }} // Adjust this value for the desired speed
            transition={{ 
                repeat: Infinity,
                duration: 20, // Adjust this value for the desired speed
                ease: "linear"
            }}
        >
            <AnimatePresence>
                {generatePhases().map((phase : any , index : any) => (
                    <motion.div 
                        key={index} 
                        className="text-[15rem] text-[#DDDACD] overflow-visible font-bold text-center m-0"
                        initial={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        {phase}
                    </motion.div>
                ))}
            </AnimatePresence>
        </motion.div>
    );
}
